import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DECORATOR__data__do_not_populate_from_linked } from '../../_base/_decorators/DECORATOR__data__do_not_populate_from_linked';
import { DECORATOR__data__reset_if_not_linked } from '../../_base/_decorators/DECORATOR__data__reset_if_not_linked';
import { ENUM__field_connectable_type } from '../../_base/_methods/ENUM__field_connectable_type';
import { FIELD_SD__conditioning } from '../../guidance/FIELD_SD__conditioning';
import { FIELD__list_base_generic } from './FIELD__list_base_generic';

export class FIELD_SD__list_conditioning extends FIELD__list_base_generic<FIELD_SD__conditioning> {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_SD__LIST_CONDITIONING;

  /*
   * STATIC METHODS
   */

  constructor() {
    super();

    this.item_connectable_type = ENUM__field_connectable_type.CONDITIONING_SD;
  }

  @DECORATOR__data__reset_if_not_linked
  @DECORATOR__data__do_not_populate_from_linked
  post_init(): void {
    super.post_init();
  }

  protected override _create_item_internal__default() {
    return new FIELD_SD__conditioning();
  }
}
